var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerVue'),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOutUp"}},[_c('router-view')],1),_c('footerVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }